<template>
    <div class="layout">
        <!-- <div class="nav"></div> -->
        <router-view />
    </div>
</template>

<script>
export default {
    name: "app"
};
</script>

<style lang="sass">
@font-face
    font-family: "Roboto";
    src: url("~@/assets/fonts/10626.ttf") format("ttf")
.layout
    background-color: $grey
    margin: 5em
    border: 1px solid $grey-l
.nav
    position: fixed
    top: 0
    left: 0
    height: 100vh
    width: 50px
    background-color: $grey-d
</style>
